

export const BOTTOM_PADDING = 26
export const CONTENT_HEIGHT = 80
export const SCENE_HEIGHT = CONTENT_HEIGHT + BOTTOM_PADDING


export const REST_BLOCK_HEIGHT = 62
